import { motion } from "motion/react";
import { Mail, Phone, MapPin } from "lucide-react";

export function Contact() {
  return (
    <section id="contact" className="py-24">
      <div className="container mx-auto px-6">
        <div className="max-w-4xl mx-auto">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true }}
            className="text-center"
          >
            <h2 className="text-4xl md:text-5xl font-serif mb-6">Get in touch</h2>
            <p className="text-muted-foreground mb-12 text-lg leading-relaxed max-w-2xl mx-auto">
              Ready to start your journey? Contact us today for a free consultation and discover how we can help you unlock your true potential.
            </p>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-16">
              <div className="flex flex-col items-center gap-4 p-8 rounded-3xl bg-muted/50">
                <div className="w-12 h-12 rounded-full bg-primary/10 flex items-center justify-center shrink-0">
                  <Mail className="w-6 h-6 text-primary" />
                </div>
                <div className="text-center">
                  <h4 className="font-semibold text-lg">Email</h4>
                  <a href="mailto:johan@iwantcoaching.co.za" className="text-muted-foreground hover:text-primary transition-colors">johan@iwantcoaching.co.za</a>
                </div>
              </div>
              <div className="flex flex-col items-center gap-4 p-8 rounded-3xl bg-muted/50">
                <div className="w-12 h-12 rounded-full bg-primary/10 flex items-center justify-center shrink-0">
                  <Phone className="w-6 h-6 text-primary" />
                </div>
                <div className="text-center">
                  <h4 className="font-semibold text-lg">Phone</h4>
                  <a href="tel:+27828293277" className="text-muted-foreground hover:text-primary transition-colors">+27 82 829 3277</a>
                </div>
              </div>
              <div className="flex flex-col items-center gap-4 p-8 rounded-3xl bg-muted/50">
                <div className="w-12 h-12 rounded-full bg-primary/10 flex items-center justify-center shrink-0">
                  <MapPin className="w-6 h-6 text-primary" />
                </div>
                <div className="text-center">
                  <h4 className="font-semibold text-lg">Location</h4>
                  <p className="text-muted-foreground">184 Koelman Rd, Ashlea Gardens, Pretoria</p>
                </div>
              </div>
            </div>

            <div className="rounded-[3rem] overflow-hidden shadow-lg border border-primary/5">
              <iframe 
                src="https://www.google.com/maps/d/embed?mid=1ZtX4C0g9WHAgG39jsKs6j8N8imvF_Xg&ehbc=2E312F&noprof=1" 
                width="100%" 
                height="450"
                style={{ border: 0 }}
                title="Iwantcoaching Location"
              ></iframe>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
}
